<template>
<div class="outer-container">
    <div class="inner-container">
        <div class="content">
            <div class="title">
                <p>LED屏幕设备管理</p>
            </div>
            <div v-if="show">
                <div class="screen_box">
                    <div v-for="(item) in screenList" :key="item.c_id" >
                        <div class="screen_box_single" @click="gotoEdit(item.c_id)">
                            <div :id="marboxId2(item.c_id)" >
                            </div>
                            <div :id="marboxId1(item.c_id)">
                                <!--    behavior 
                                            alternate 两端相互滚动
                                            scroll 一端到另一端 会重复  
                                            slide 一端到另一端 不会重复 
                                        scrolldelay 两次循环之间的延迟 毫秒
                                        scrollamount 字母滚动速度 单位pixels
                                        loop 循环次数 -1为无限循环 
                                        direction 滚动方向
                                -->
                                <!-- <marquee id="marqueeBox"></marquee> -->
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- edit by ghc 2020.9.14 start -->
            <div style="display:flex;flex-direction:row;justify-content:center;background-color:#cccccc;margin-top:-10px; margin-bottom:30px">
                <!-- <div style="background-color:white;width:80vw;display:flex;justify-content:center;padding:8px 0;border-radius:5px">
                    +添加屏幕
                </div> -->
                <el-button style="width:90vw;display:flex;justify-content:center;padding:8px 0;border-radius:5px" type="primary" @click="addScreen"> +添加屏幕</el-button>
            </div>
             <!-- edit by ghc 2020.9.14 end -->
        </div>
    </div>
</div>
</template>

<script>
import CYTApi from "@/api/cyt";
export default {
    data(){
        return{
            screenList:[],//屏幕列表
            showScreen:[],//展示的数据面板
            name:"测试",
            show:false,
        }
    },
    methods:{
        initScreen(){
            this.show = true;
            this.$nextTick(()=>{
                this.screenList.forEach(screen=>{
                    //屏幕设置
                    var screenDiv = document.getElementById("main_screen"+screen.c_id);
                    screenDiv.style.width = "96vw";
                    screenDiv.style.margin = "0 auto";
                    screenDiv.style.position = "relative";
                    var height = 96*screen.c_high/screen.c_width;
                    var font_size = screen.c_high/16;
                    screenDiv.style.height = height+"vw";
                    screenDiv.style.lineHeight = height/font_size+"vw";
                    screenDiv.style.backgroundColor = "#000000";
                    screenDiv.style.fontSize = height/font_size+"vw";
                    //屏幕名称
                    var screenTitleDiv = document.getElementById("screen_title"+screen.c_id);
                    var titleDiv = document.createElement('div');
                    titleDiv.style.width = "96vw";
                    titleDiv.style.margin = "0 auto";
                    titleDiv.innerHTML = "屏幕名称:"+screen.c_desc+"<br/>屏幕描述:该屏幕用于办公司屏幕测试";
                    screenTitleDiv.appendChild(titleDiv);
                })
            })
        },
        mainScreenSytle(){
            this.$nextTick(()=>{
                this.showScreen.forEach(screenData=>{
                    for(var i=0;i<screenData.length;i++){
                        var obj =screenData[i];
                        var screenDiv = document.getElementById("main_screen"+obj.screen_id);
                        var height = 96*obj.c_high/obj.c_width;
                        if(obj.c_auto_flag==1){
                            if(obj.c_way==0){
                                //主屏幕字幕的设置
                                var textDiv = document.createElement('div');
                                //处理颜色
                                var text = obj.c_text;
                                var index_arr = [];
                                var text_arr = [];
                                //处理C1 C2颜色
                                var index_C1 = text.indexOf('C1'); // 字符出现的位置
                                var num = 0; // 这个字符出现的次数
                                while(index_C1 !== -1) {
                                    index_arr.push({"name":"C1","location":index_C1});
                                    num++; // 每出现一次 次数加一
                                    index_C1 = text.indexOf('C1',index_C1 + 1); // 从字符串出现的位置的下一位置开始继续查找
                                }
                                var index_C2 = text.indexOf('C2'); // 字符出现的位置
                                while(index_C2 !== -1) {
                                    index_arr.push({"name":"C2","location":index_C2});
                                    num++; // 每出现一次 次数加一
                                    index_C2 = text.indexOf('C2',index_C2 + 1); // 从字符串出现的位置的下一位置开始继续查找
                                }
                                index_arr.sort((a,b)=>{
                                    return (a.location - b.location)>0 ? 1:-1;
                                })
                                if(index_arr.length!=0){
                                    for(var j=0;j<index_arr.length-1;j++){
                                        var type = index_arr[j].name;
                                        var slice_text = text.slice(index_arr[j].location+2,index_arr[j+1].location);
                                        text_arr.push({"type":type,"text":slice_text});
                                    }
                                    var last_index = index_arr.length;
                                    var type = index_arr[last_index-1].name;
                                    var slice_text = text.slice(index_arr[last_index-1].location+2,text.length);
                                    text_arr.push({"type":type,"text":slice_text});
                                    //开始拼接内容
                                    for(let j=0;j<text_arr.length;j++){
                                        var textPartDiv = document.createElement('div');
                                            if(text_arr[j].type == "C1"){
                                                textPartDiv.style.color = "#F56C6C";
                                            }else if(text_arr[j].type =="C2"){
                                                textPartDiv.style.color = "#67C23A";
                                        }
                                        textPartDiv.innerHTML = text_arr[j].text;
                                        textDiv.appendChild(textPartDiv);
                                    }
                                }else{
                                    var textPartDiv = document.createElement('div');
                                    textPartDiv.style.color = "#F56C6C";
                                    textPartDiv.innerHTML =text;
                                    textDiv.appendChild(textPartDiv);
                                }
                                //字幕位置设置
                                textDiv.style.width = 96*(obj.c_w/obj.c_width);
                                textDiv.style.height = height*(obj.c_h/obj.c_high)+"vw";
                                textDiv.style.whiteSpace = "nowrap";
                                textDiv.style.overflow = "hidden";
                                textDiv.style.textOverflow = "clip";
                                textDiv.style.position = "absolute";
                                var font_size = obj.c_high/16;
                                textDiv.style.left = obj.c_x*(height/(font_size*2))+"vw";
                                // textDiv.style.left = (obj.c_x/obj.c_width)*100+"%";
                                textDiv.style.top = (obj.c_y/obj.c_high)*100+"%";
                                textDiv.style.display = "flex";
                                textDiv.style.flexDirection = "row";
                                textDiv.style.flexWrap = "nowrap";
                                screenDiv.appendChild(textDiv);
                            }else if(obj.c_way == 1){
                                var textDiv = document.createElement('div');
                                textDiv.innerHTML = "<marquee id='marqueeBox"+obj.screen_id+i+"'></marquee>";
                                //动态弹幕部分设置
                                screenDiv.appendChild(textDiv);
                                var maqrueenDiv = document.getElementById("marqueeBox"+obj.screen_id+i);
                                // maqrueenDiv.direction = "up"; //滚动方向
                                if(obj.c_mode==0){
                                    maqrueenDiv.scrollAmount = "0";
                                }else {
                                    maqrueenDiv.scrollAmount = obj.c_speed;  //滚动速度
                                    if(obj.c_mode==2){
                                        maqrueenDiv.direction = "left";
                                    }else if(obj.c_mode==3){
                                        maqrueenDiv.direction = "right";
                                    }else if(obj.c_mode==4){
                                        maqrueenDiv.direction = "up";
                                    }else if(obj.c_mode==5){
                                        maqrueenDiv.direction = "down";
                                    }
                                }
                                // maqrueenDiv.behavior = "slide"; //滚动方式
                                var text = obj.c_text;
                                var index_arr = [];
                                var text_arr = [];
                                //处理C1 C2颜色
                                var index_C1 = text.indexOf('C1'); // 字符出现的位置
                                var num = 0; // 这个字符出现的次数
                                while(index_C1 !== -1) {
                                    index_arr.push({"name":"C1","location":index_C1});
                                    num++; // 每出现一次 次数加一
                                    index_C1 = text.indexOf('C1',index_C1 + 1); // 从字符串出现的位置的下一位置开始继续查找
                                }
                                var index_C2 = text.indexOf('C2'); // 字符出现的位置
                                while(index_C2 !== -1) {
                                    index_arr.push({"name":"C2","location":index_C2});
                                    num++; // 每出现一次 次数加一
                                    index_C2 = text.indexOf('C2',index_C2 + 1); // 从字符串出现的位置的下一位置开始继续查找
                                }
                                index_arr.sort((a,b)=>{
                                    return (a.location - b.location)>0 ? 1:-1;
                                })
                                if(index_arr.length!=0){
                                    for(var j=0;j<index_arr.length-1;j++){
                                        var type = index_arr[j].name;
                                        var slice_text = text.slice(index_arr[j].location+2,index_arr[j+1].location);
                                        text_arr.push({"type":type,"text":slice_text});
                                    }
                                    var last_index = index_arr.length;
                                    var type = index_arr[last_index-1].name;
                                    var slice_text = text.slice(index_arr[last_index-1].location+2,text.length);
                                    text_arr.push({"type":type,"text":slice_text});
                                    //开始拼接内容
                                    var textOutterDiv = document.createElement('div');
                                    for(let k=0;k<text_arr.length;k++){
                                        var textPartDiv = document.createElement('div');
                                            if(text_arr[k].type == "C1"){
                                                textPartDiv.style.color = "#F56C6C";
                                            }else if(text_arr[k].type =="C2"){
                                                textPartDiv.style.color = "#67C23A";
                                        }
                                        textPartDiv.innerHTML = text_arr[k].text;
                                        textOutterDiv.appendChild(textPartDiv);
                                    }
                                    textOutterDiv.style.display = "flex";
                                    textOutterDiv.style.flexDirection = "row";
                                    textOutterDiv.style.flexWrap = "nowrap";
                                    maqrueenDiv.appendChild(textOutterDiv);
                                }else{
                                    var textPartDiv = document.createElement('div');
                                    textPartDiv.style.color = "#F56C6C";
                                    textPartDiv.innerHTML =text;
                                    maqrueenDiv.appendChild(textPartDiv);
                                }
                                //字幕位置设置
                                maqrueenDiv.style.width = 96*(obj.c_w/obj.c_width);;
                                textDiv.style.height = height*(obj.c_h/obj.c_high)+"vw";
                                textDiv.style.whiteSpace = "nowrap";
                                textDiv.style.overflow = "hidden";
                                textDiv.style.textOverflow = "clip";
                                textDiv.style.position = "absolute";
                                textDiv.style.left = obj.c_x*(height/8)+"vw";
                                textDiv.style.top = (obj.c_y/obj.c_high)*100+"%";
                            }
                        }else if(obj.c_auto_flag==0){
                            if(obj.c_way==2){
                                var textDiv = document.createElement('div');
                                textDiv.innerHTML = "<marquee id='marqueeBox"+obj.screen_id+i+"'></marquee>";
                                //动态弹幕部分设置
                                screenDiv.appendChild(textDiv);
                                var maqrueenDiv = document.getElementById("marqueeBox"+obj.screen_id+i);
                                // maqrueenDiv.direction = "up"; //滚动方向
                                if(obj.c_mode==0){
                                    maqrueenDiv.scrollAmount = "0";
                                }else {
                                    maqrueenDiv.scrollAmount = obj.c_speed;  //滚动速度
                                    if(obj.c_mode==2){
                                        maqrueenDiv.direction = "left";
                                    }else if(obj.c_mode==3){
                                        maqrueenDiv.direction = "right";
                                    }else if(obj.c_mode==4){
                                        maqrueenDiv.direction = "up";
                                    }else if(obj.c_mode==5){
                                        maqrueenDiv.direction = "down";
                                    }
                                }
                                // maqrueenDiv.behavior = "slide"; //滚动方式
                                var text = obj.c_text;
                                var index_arr = [];
                                var text_arr = [];
                                //处理C1 C2颜色
                                var index_C1 = text.indexOf('C1'); // 字符出现的位置
                                var num = 0; // 这个字符出现的次数
                                while(index_C1 !== -1) {
                                    index_arr.push({"name":"C1","location":index_C1});
                                    num++; // 每出现一次 次数加一
                                    index_C1 = text.indexOf('C1',index_C1 + 1); // 从字符串出现的位置的下一位置开始继续查找
                                }
                                var index_C2 = text.indexOf('C2'); // 字符出现的位置
                                while(index_C2 !== -1) {
                                    index_arr.push({"name":"C2","location":index_C2});
                                    num++; // 每出现一次 次数加一
                                    index_C2 = text.indexOf('C2',index_C2 + 1); // 从字符串出现的位置的下一位置开始继续查找
                                }
                                index_arr.sort((a,b)=>{
                                    return (a.location - b.location)>0 ? 1:-1;
                                })
                                if(index_arr.length!=0){
                                    for(var j=0;j<index_arr.length-1;j++){
                                        var type = index_arr[j].name;
                                        var slice_text = text.slice(index_arr[j].location+2,index_arr[j+1].location);
                                        text_arr.push({"type":type,"text":slice_text});
                                    }
                                    var last_index = index_arr.length;
                                    var type = index_arr[last_index-1].name;
                                    var slice_text = text.slice(index_arr[last_index-1].location+2,text.length);
                                    text_arr.push({"type":type,"text":slice_text});
                                    //开始拼接内容
                                    var textOutterDiv = document.createElement('div');
                                    for(let k=0;k<text_arr.length;k++){
                                        var textPartDiv = document.createElement('div');
                                            if(text_arr[k].type == "C1"){
                                                textPartDiv.style.color = "#F56C6C";
                                            }else if(text_arr[k].type =="C2"){
                                                textPartDiv.style.color = "#67C23A";
                                        }
                                        textPartDiv.innerHTML = text_arr[k].text;
                                        textOutterDiv.appendChild(textPartDiv);
                                    }
                                    textOutterDiv.style.display = "flex";
                                    textOutterDiv.style.flexDirection = "row";
                                    textOutterDiv.style.flexWrap = "nowrap";
                                    maqrueenDiv.appendChild(textOutterDiv);
                                }else{
                                    var textPartDiv = document.createElement('div');
                                    textPartDiv.style.color = "#F56C6C";
                                    textPartDiv.innerHTML =text;
                                    maqrueenDiv.appendChild(textPartDiv);
                                }
                                //字幕位置设置
                                maqrueenDiv.style.width = 96*(obj.c_w/obj.c_width);;
                                textDiv.style.height = height*(obj.c_h/obj.c_high)+"vw";
                                textDiv.style.whiteSpace = "nowrap";
                                textDiv.style.overflow = "hidden";
                                textDiv.style.textOverflow = "clip";
                                textDiv.style.position = "absolute";
                                textDiv.style.left = obj.c_x*(height/8)+"vw";
                                textDiv.style.top = (obj.c_y/obj.c_high)*100+"%";
                            }
                        }
                    }
                })
            })
        },
        getAllScreen(){
            CYTApi.getAllScreen().then(response => {
                var screenList = response.data.screenlist;
                var screenDataList = response.data.screenData;
                var showScreenList = [];
                screenList.forEach(item=>{
                    var tempList = [];
                    screenDataList.forEach(item2=>{
                        if(item2.screen_id == item.c_id){
                            tempList.push(item2);
                        }
                    })
                    if(tempList.length!=0){
                        showScreenList.push(tempList);
                    }
                })
                this.screenList = screenList;
                this.showScreen = showScreenList;
                this.initScreen();
                if(this.showScreen[0]){
                    this.mainScreenSytle();
                }
            });
        },
        marboxId1(i){
            return "main_screen" + i;
        },
        marboxId2(i){
            return "screen_title" + i;
        },
        gotoEdit(id){
              this.$router.push("/screen/log/"+id);
        },
        addScreen(){
            this.$router.push(`/add_screen`)
        }
    },
    mounted(){
        this.getAllScreen();
    }
}
</script>
<style scoped>
/* .screen_class{
    border:1px solid;
} */
.title{
    width: 100vw;
    height: 10vh;
    background-image: url("../../assets/title.jpg");
    background-repeat: no-repeat;
    background-size: cover;
    color: white;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 30px;
    margin-bottom: 5px;
}
.screen_box{
    width: 100vw;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-content: center;
    margin-bottom: 20px;
    background-color: #cccccc;
    /* border:1px solid; */
}
.screen_box_single{
    padding: 10px 5px;
    border:1px solid;
    border-radius: 5px;
    margin:0 auto;
    display:flex;
    flex-direction:column;
    margin-bottom:20px;
    background-color: white;
}

.outer-container,.content {
    display: flex;
    flex-direction: column;
    width: 100vw; height: 100vh;
    background-color: #cccccc;
}
.outer-container {
    position: relative;
    overflow: hidden;
}
.inner-container {
    position: absolute; left: 0;
    overflow-x: hidden;
    overflow-y: scroll;
}
 
 /* for Chrome */
.inner-container::-webkit-scrollbar {
    display: none;
}

</style>


// WEBPACK FOOTER //
// src/views/MQTT/Preview_Mqtt.vue